export const environment = {
    production: false,
    envName: 'staging',
    gitCommit: 'GIT_COMMIT',
    buildNumber: 'BUILD_NUMBER',
    firebase: {
        apiKey: 'AIzaSyCH2guyhFTbNkMsqq_3khmCNq5kdg3SJqE',
        authDomain: 'staitment-test.firebaseapp.com',
        databaseURL: 'https://staitment-test.firebaseio.com',
        projectId: 'staitment-test',
        storageBucket: 'staitment-test.appspot.com',
        messagingSenderId: '823025839840',
        appId: '1:823025839840:web:ca4da87258fc86149cea85'
    },
    rootDomain: 'https://audit-staging.swipesum.com',
    pdfUrl: 'https://audit-pdf-staging.swipesum.com',
    pdfHeader: null, //{ 'swipesum-origin': 'pdf-test' },
    apiUrl: 'https://audit-server-staging.swipesum.com',
    apiHeader: { 'swipesum-origin': 'audit-staging' },
    portalUrl: 'https://audit-server-staging.swipesum.com',
    externalApiUrl: 'https://us-central1-staitment-test.cloudfunctions.net/externalApi',
    checkUsersUrl: 'https://us-central1-staitment-test.cloudfunctions.net/checkUsers',
    embedUrl: 'https://staitment-test-embed.web.app/',
    suiteUrl: 'https://cpo-staging.swipesum.com',
    gatewayUrl: 'https://gateway-staging.swipesum.com',
    gatewayMerchantId: '7965bb6d-2e67-4927-bfaa-242f9c3dbc91',
    swipesumExternalApiUrl: 'https://external-api-staging.swipesum.com'
};

